document.addEventListener('DOMContentLoaded', () => {
    const HOVER_DELAY = 800; // 0.8 seconds
    const SLIDE_INTERVAL = 1500; // 1.5 seconds per slide

    function initHoverEffect(card) {
        // Prevent double initialization
        if (card.dataset.hoverInitialized === 'true') return;
        card.dataset.hoverInitialized = 'true';

        let hoverTimeout;
        let slideInterval;
        let currentSlideIndex = 0;

        const galleryImages = card.querySelectorAll('.card__media-gallery-item');
        const mainImage = card.querySelector('.card__media-main') || card.querySelector('img');

        // Only enable if we have gallery images
        if (galleryImages.length === 0) return;

        card.addEventListener('mouseenter', () => {
            hoverTimeout = setTimeout(() => {
                activateHover(card, galleryImages, mainImage);
            }, HOVER_DELAY);
        });

        card.addEventListener('mouseleave', () => {
            clearTimeout(hoverTimeout);
            deactivateHover(card, galleryImages, mainImage);
        });

        function activateHover(card, images, mainImg) {
            card.classList.add('hover-active');

            // Start slideshow
            currentSlideIndex = 0;
            showImage(images, currentSlideIndex); // Show first gallery image immediately

            slideInterval = setInterval(() => {
                currentSlideIndex = (currentSlideIndex + 1) % images.length;
                showImage(images, currentSlideIndex);
            }, SLIDE_INTERVAL);
        }

        function deactivateHover(card, images, mainImg) {
            card.classList.remove('hover-active');
            clearInterval(slideInterval);

            // Reset images
            images.forEach(img => {
                img.classList.add('hidden');
                img.style.opacity = '0';
            });
            if (mainImg) mainImg.style.opacity = '1';
        }

        function showImage(images, index) {
            // Hide all gallery images first
            images.forEach((img, i) => {
                if (i === index) {
                    img.classList.remove('hidden');
                    // Small delay to allow CSS transition if needed, or just set opacity
                    requestAnimationFrame(() => {
                        img.style.opacity = '1';
                    });
                } else {
                    img.style.opacity = '0';
                    // Delay hiding to allow crossfade
                    setTimeout(() => {
                        if (i !== index) img.classList.add('hidden');
                    }, 500); // Match CSS transition
                }
            });
        }
    }

    // Initialize existing cards
    document.querySelectorAll('.product-card-wrapper').forEach(initHoverEffect);

    // Observer to handle dynamically loaded cards (e.g., Collection filtering, Search, Infinite Scroll)
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1) { // Element node
                    // Check if the node itself is a card
                    if (node.classList.contains('product-card-wrapper')) {
                        initHoverEffect(node);
                    }
                    // Check if the node contains cards
                    if (node.querySelectorAll) {
                        node.querySelectorAll('.product-card-wrapper').forEach(initHoverEffect);
                    }
                }
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});
